import React from 'react';
import { gujUnicodeToEnglish, gujUnicodeToHindi, gujUnicodeToSulekh, hindiUnicodeToGujUnicode, newGujUnicodeToHindiUnicode, sulekhToGujUnicodeConverter } from '../../services/converter.service';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const Converter = () => {

    const navigate = useNavigate();

    const gujUnicodeButtonPress = async () => {
        const unicodeText = document.getElementById('unicodeText').value;
        // const convertedeHindi = gujUnicodeToHindi(unicodeText);
        const convertedeHindi = newGujUnicodeToHindiUnicode(unicodeText);
        document.getElementById('hindiUnicode').value = convertedeHindi;
        const convertedEnglish = gujUnicodeToEnglish(unicodeText);
        document.getElementById('englishText').value = convertedEnglish;
        const convertedSulekh = gujUnicodeToSulekh(unicodeText);
        document.getElementById('sulekhText').value = convertedSulekh;
    };

    const sulekhTextButtonPress = async () => {
        const sulekhText = document.getElementById('sulekhText').value;
        const convertedUnicode = sulekhToGujUnicodeConverter(sulekhText);
        document.getElementById('unicodeText').value = convertedUnicode;
        const convertedEnglish = gujUnicodeToEnglish(convertedUnicode);
        document.getElementById('englishText').value = convertedEnglish;
        // const convertedHindi = gujUnicodeToHindi(convertedUnicode);
        const convertedHindi = newGujUnicodeToHindiUnicode(convertedUnicode);
        document.getElementById('hindiUnicode').value = convertedHindi;
    };

    const hindiUnicodeButtonPress = async () => {
        const hindiUnicode = document.getElementById('hindiUnicode').value;
        const convertedUnicode = hindiUnicodeToGujUnicode(hindiUnicode);
        document.getElementById('unicodeText').value = convertedUnicode;
        const convertedEnglish = gujUnicodeToEnglish(convertedUnicode);
        document.getElementById('englishText').value = convertedEnglish;
        const convertedSulekh = gujUnicodeToSulekh(convertedUnicode);
        document.getElementById('sulekhText').value = convertedSulekh;
    };

    return (
        <div className='bg-[#dfb693] h-full'>
            <div className="xl:mx-20 py-8 lg:px-6 sm:px-3 p-2">
                <h1 className="text-4xl font-bold text-center mb-8">જય શ્રી સ્વામિનારાયણ</h1>
                <button className="absolute top-1 right-2 px-1 pb-1 text-xl bg-red-600 text-white rounded-full" onClick={() => { navigate('/'); }}><ArrowBackIcon /></button>
                <div className="grid grid-cols-2 gap-8">
                    <div className="flex flex-col gap-6">
                        <div>
                            <label htmlFor="message" className="block mb-2 text-3xl font-medium text-gray-900">ગુજરાતી યુનિકોડ
                            </label>
                            <textarea id="unicodeText" className="w-full h-64 border-2 rounded-3xl border-gray-300 p-2 text-lg bg-[#f3d5b7]"
                                spellCheck="false"></textarea>
                        </div>
                        <input className="block w-full p-2 border-2 border-black rounded-full text-center cursor-pointer text-xl bg-[#D89f64] text-white "
                            type="button" accessKey="c" title="Sulekh To English"
                            onClick={() => { gujUnicodeButtonPress(); }}
                            value="Convert " />
                    </div>
                    <div className="flex flex-col gap-6">
                        <div>
                            <label htmlFor="message" className="block mb-2 text-3xl font-medium text-gray-900">સુલેખ </label>
                            <textarea id="sulekhText" style={{ fontFamily: 'Guj_Gopika_Two_Bold' }}
                                className="w-full  h-64 border-2 rounded-3xl border-gray-300 p-2 text-lg bg-[#f3d5b7]"
                                spellCheck="false"></textarea>
                        </div>
                        <input className="block w-full p-2 border-2 border-black rounded-full text-center cursor-pointer text-xl bg-[#D89f64] text-white"
                            type="button" accessKey="c" title="Unicode To English"
                            onClick={() => { sulekhTextButtonPress(); }}
                            value="Convert " />
                    </div>
                    <div className="flex flex-col gap-6">
                        <div>
                            <label htmlFor="message"
                                className="block mb-2 text-3xl font-medium text-gray-900">હિન્દી યુનિકોડ</label>
                            <textarea id="hindiUnicode" className="w-full  h-64 border-2 rounded-3xl border-gray-300 p-2 text-lg bg-[#f3d5b7]"
                                spellCheck="false"></textarea>
                        </div>
                        <input className="block w-full p-2 border-2 border-black rounded-full text-center cursor-pointer text-xl bg-[#D89f64] text-white"
                            type="button" accessKey="c" title="Sulekh To English"
                            onClick={() => { hindiUnicodeButtonPress(); }}
                            value="Convert " />
                    </div>
                    <div className="flex flex-col gap-6">
                        <div>
                            <label htmlFor="message" className="block mb-2 text-3xl font-medium text-gray-900">અંગ્રેજી_ટેક્સ્ટ</label>
                            <textarea id="englishText" className="w-full  h-64 border-2 rounded-3xl border-gray-300 p-2 text-lg bg-[#f3d5b7]"
                                spellCheck="false"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Converter;
